var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:[
        {
            'form-row': _vm.horizontal,
        } ]},[_c('label',{class:[
            { 'col-form-label': _vm.horizontal },
            _vm.horizontal ? _vm.class_label : '',
            _vm.size == 'sm' ? 'col-form-label-sm' : '' ]},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{class:[
            _vm.horizontal ? _vm.class_input : '',
            _vm.size == 'sm' ? 'input-group-sm' : '',
            'codemirror-wrapped'
        ]},[_c('codemirror',{ref:"cmEditor",attrs:{"value":_vm.code,"options":_vm.cmOptions},on:{"ready":_vm.onCmReady,"focus":_vm.onCmFocus,"input":_vm.onCmCodeChange}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }